import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import { globalSystemColors } from '../../../styled/theme/constants';

export const NavContainer = styled.div`
  display: flex;
  white-space: nowrap;
  margin-bottom: 15px;
  border-radius: 50px;
  padding: 5px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: rgba(232, 232, 232, 0.4);
  backdrop-filter: blur(16px);
  position: sticky;
  bottom: 50px;
  z-index: 5;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${Breakpoints.tablet}px) {
    position: sticky;
    bottom: 60px;
    transform: none;
    left: auto;
    right: auto;
    margin-left: auto;
    margin-right: 15px;
  }
`;

export const NavMain = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const NavItem = styled.div<{ active?: boolean; highlight?: boolean }>`
  padding: 12px 15px;
  border-radius: 20px;
  text-decoration: none;
  background-color: ${({ active, highlight, theme }) => {
    if (highlight) return globalSystemColors.blue;
    if (active) return globalSystemColors.white;
    return 'transparent';
  }};
  color: ${({ active, highlight, theme }) => {
    if (highlight) return globalSystemColors.white;
    if (active) return globalSystemColors.cocoaBrown;
    return theme.colors.text.primary;
  }};
  cursor: pointer;
  font-size: 14px;
  -webkit-tap-highlight-color: transparent;

  @media (hover: hover) and (pointer: fine) {
    ${({ highlight, theme }) =>
      highlight &&
      css`
        margin-left: 10px;
        &:hover {
          background: #2744c4;
          color: ${theme.colors.text.primary};
        }
      `}
  }
`;
